/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Credentials_Status_Missing_TitleInputs */



/**
* | output |
* | --- |
* | "No credentials yet" |
*
* @param {Integrations_Credentials_Status_Missing_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_credentials_status_missing_title = /** @type {((inputs?: Integrations_Credentials_Status_Missing_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Credentials_Status_Missing_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Zugangsdaten")
	return /** @type {LocalizedString} */ ("No credentials yet")
});